module.exports = __webpack_public_path__ + "media/Video 1b.94007071.mp4";